module.exports = __webpack_public_path__ + "img/GH-kyujin-top-029.703664bd.webp";